enum TransactionTypes {
  BUY = 'Buy',
  SELL = 'Sell',
}

export default TransactionTypes;
